import { Button } from '@eventbrite/eds-button';
import { GenericLazyString } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import './AuthDialog.scss';
import AuthDialogIcon, { IAuthDialogIconProps } from './AuthDialogIcon';

interface IButtonProps {
    buttonText: GenericLazyString | undefined;
    handleOnClick: () => void;
}

export interface IAuthDialogProps {
    icon?: IAuthDialogIconProps;
    titleText: GenericLazyString;
    subtitleTextDark?: GenericLazyString;
    subtitleText?: GenericLazyString;
    button?: IButtonProps;
    noWrapperStyles?: boolean;
    slimTitles?: boolean;
}

// Renders a 'dialog' style message with a dark centered icon by default, two messages (one of wich is lighter in colour) and a darker link button
const AuthDialog = ({
    icon = {},
    titleText,
    subtitleTextDark,
    subtitleText,
    button,
    noWrapperStyles,
    slimTitles,
}: IAuthDialogProps) => {
    const { iconColor, iconType, isLoading } = icon;
    const buttonText = button?.buttonText;
    const handleOnClick = button?.handleOnClick;

    const titleClasses = classNames('eds-text--center', {
        'eds-l-mar-hor-3 eds-l-mar-bot-8': slimTitles,
        'eds-text-hm eds-l-mar-bot-4': !slimTitles,
    });
    const subTitleClasses = classNames(
        'eds-text-bm eds-text--center eds-l-mar-hor-3',
        {
            'eds-l-mar-bot-8': slimTitles,
            'eds-l-mar-bot-4': !slimTitles,
        },
    );
    const graySubTitleClasses = classNames(
        subTitleClasses,
        'eds-text-color--grey-600',
    );

    return (
        <div
            className={noWrapperStyles ? '' : 'auth-lib__auth-dialog'}
            data-testid="auth-dialog-container"
        >
            <AuthDialogIcon
                iconType={iconType}
                iconColor={iconColor}
                isLoading={isLoading}
            />

            <h2 className={titleClasses}>{titleText}</h2>

            {subtitleTextDark && (
                <div
                    className={subTitleClasses}
                    data-testid="auth-dialog-subtitle-text-dark"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: subtitleTextDark?.toString(),
                    }}
                />
            )}

            {subtitleText && (
                <div
                    className={graySubTitleClasses}
                    data-testid="auth-dialog-subtitle-text"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: subtitleText?.toString(),
                    }}
                />
            )}

            {buttonText && (
                <div
                    className="eds-align--center-horizontal"
                    data-testid="auth-dialog-button"
                >
                    <Button
                        style="link"
                        onClick={handleOnClick}
                        __containerClassName="auth-lib__auth-dialog__button"
                    >
                        {buttonText}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default AuthDialog;
